import axios from "axios";
const baseURL = process.env.REACT_APP_API_URL;
export const get_all_active_applications = async () => {
    let response = await axios.get(baseURL + "/active-applications");
    return response.data;
}
export const get_all_inactive_applications = async () => {
    let response = await axios.get(baseURL + "/inactive-applications");
    return response.data;
}
export const change_application_status = async (id: number) => {
    let response = await axios.delete(baseURL + "/active-application/" + id);
    return response.data;
}
// Application View
export const get_application_details= async (organizationId, applicationId,apiUrl) => {
    const response = await axios.post(`https://${apiUrl}/api/get-all-tenant`, {
        "organization_id": organizationId,
        "application_id": applicationId
    });
    return response.data;
};
// update-application-organization-status
export const update_application_organization_status= async (organizationId, applicationId,status) => {
    const response = await axios.post(`${baseURL}/update-application-organization-status`, {
        "organization_id": organizationId,
        "application_id": applicationId,
        is_active:status
    });
    return response.data;
};
// Get get_single_application by ID
export const get_single_application = async (id) => {
    let response = await axios.get(`${baseURL}/application/${id}`);
    return response.data;
};
export const single_user_application_log = async (id) => {
    let response = await axios.get(`${baseURL}/single-user-application-log/${id}`);
    return response.data;
};